<template>
  <div class="dHWEnergyPage" v-loading="$store.state.user.loadingState">
    <AnalysisHead @getActiveTime="getActiveTime" />
    <div class="topBox">
      <div class="analysis ashComWrap">
        <div class="comTitle">
          <h4>用能分析</h4>
        </div>
        <div class="comContentBox comFlex">
          <div class="overviewWrap secondAshComWrap">
            <div class="comTitle">
              <h4>总览</h4>
            </div>
            <div class="comContentBox">
              <div v-for="(v, i) in overviewData" :key="i" class="overviewLi">
                <AnalysisOverview :overviewData="v" />
              </div>
            </div>
          </div>
          <div class="gasTop secondAshComWrap">
            <div class="comTitle">
              <!--  topActive == "ec"
                    ? "用电"
                    : topActive == "gc"
                    ? "用气"
                    : "用水" -->
              <h4>{{ matchingECMode(topActive) }}TOP5</h4>
              <el-radio-group
                v-model="topActive"
                size="mini"
                @change="getGasTop"
              >
                <el-radio-button label="ec">用电</el-radio-button>
                <el-radio-button label="gc">用气</el-radio-button>
                <el-radio-button label="fc">用水</el-radio-button>
              </el-radio-group>
            </div>
            <div class="comContentBox">
              <PublicEcharts
                :id="'gasTop'"
                :chartsData="gasTopList"
                :type="'horizontalBar'"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="runTime ashComWrap">
        <div class="comTitle">
          <h4>锅炉运行时长</h4>
        </div>
        <div class="comContentBox">
          <PublicEcharts
            :id="'DHWrunTime'"
            :chartsData="runTimeList"
            :type="'lightLine'"
          />
        </div>
      </div>
    </div>
    <AnalysisTwoChart
      :leftCharts="hoursCharts"
      :rightCharts="electricityCharts"
      :leftTitle="'24小时用能分析'"
      :rightTitle="rightTitle"
      @getActiveItem="getActiveItem"
    />
    <AnalysisTable
      :title="'用电详情表'"
      :tabHead="tabHead"
      :tableData="tableData"
      :excelTitle="excelTitle"
      :showDownload="judgeAuthority('zixitong:shenghuoreshui:dHWEnergy:export')"
    />
  </div>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  judgeAuthority,
  matchingECMode,
  handleNumDecimal,
} from "@/assets/js/utils";
import AnalysisHead from "@/components/fenxizujian/AnalysisHead";
import AnalysisTwoChart from "@/components/fenxizujian/AnalysisTwoChart";
import AnalysisTable from "@/components/fenxizujian/AnalysisTable";
import PublicEcharts from "@/components/PublicEcharts";
import AnalysisOverview from "@/components/fenxizujian/AnalysisOverview";
export default {
  components: {
    AnalysisHead,
    AnalysisTwoChart,
    AnalysisTable,
    PublicEcharts,
    AnalysisOverview,
  },
  data() {
    return {
      activeTime: {},
      rightTitle: "",
      excelTitle: "",
      topActive: "ec",
      hoursCharts: {
        title: "",
        unit: "",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      electricityCharts: {
        unit: "",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      runTimeList: {
        unit: "h",
        type: "line",
        xData: [],
        dataArr: [],
      },
      tableData: [],
      tabHead: [],
      overviewData: [],
      gasTopList: {
        name: "",
        unit: "",
        xData: [],
        yData: [],
      },
      hoursActive: "cc",
      dateActive: "cc",
      pubParams: {},
    };
  },
  methods: {
    judgeAuthority,
    matchingECMode,
    getActiveItem(data) {
      this[data.type] = data.data;
      if (data.type == "dateActive") {
        this.getEcData();
      } else if (data.type == "hoursActive") {
        this.getFourEC();
      }
    },
    getTableHeade() {
      this.tabHead = [
        { label: "时间", prop: "time" },
        {
          label: `综合碳耗/${
            this.activeTime.type == "MONTH" ? "kgCO₂" : "万kgCO₂"
          }`,
          prop: "carbonAll",
        },
        {
          label: `用气/${this.activeTime.type == "MONTH" ? "m³" : "万m³"}`,
          prop: "gasAll",
        },
        {
          label: `用水/${this.activeTime.type == "MONTH" ? "m³" : "万m³"}`,
          prop: "flowAll",
        },
        {
          label: `用电/${this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"}`,
          prop: "electricityAll",
        },
        {
          label: `燃烧风机用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "combustionFan",
        },
        {
          label: `空气源热泵用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "airSourceHeatPump",
        },
        {
          label: `电锅炉用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "boiler",
        },
        {
          label: `锅炉循环泵用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "boilerHotWaterCirculationPump",
        },
        {
          label: `热水循环泵用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "domesticHotWaterCirculationPump",
        },
      ];
    },
    getActiveTime(val) {
      this.$store.commit("SET_LOADING", true);
      this.activeTime = val;
      this.getTableHeade();
      this.excelTitle = `生活热水系统分析-${
        val.timeValue ? val.timeValue : "全部"
      }`;
      this.pubParams = {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        assetType: "生活热水系统",
        type: this.activeTime.type,
        date: this.activeTime.timeValue,
      };
      this.getOverview();
      this.getGasTop();
      this.getRunTime();
      this.getEcData();
      this.getFourEC();
      this.getTable();

      if (val.type == "MONTH") {
        this.rightTitle = "每日用电排行";
      } else if (val.type == "YEAR") {
        this.rightTitle = "每月用能趋势";
      } else {
        this.rightTitle = "每年用能趋势";
      }

      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 1000);
    },

    // 获取概览
    async getOverview() {
      this.overviewData = [];
      let res = await api.DHWAnalysisOverview(this.pubParams);
      if (res && res.data.code == 200) {
        this.overviewData = Array.from(res.data.data).map((item) => ({
          title: item.name,
          num: handleNumDecimal(
            item.values.value > 10000
              ? item.values.value / 10000
              : item.values.value
          ),
          unit:
            item.values.value > 10000
              ? "万" + item.values.unit
              : item.values.unit,
          yoy: item.values.charts.find((v) => {
            return v.name == "同比";
          })?.value,
          mom: item.values.charts.find((v) => {
            return v.name == "环比";
          })?.value,
        }));
      }
    },

    async getGasTop() {
      this.gasTopList.name = matchingECMode(this.topActive);
      this.gasTopList.unit = this.topActive == "ec" ? "kw·h" : "m³";
      this.gasTopList.xData = [];
      this.gasTopList.yData = [];
      let params = Object.assign(this.pubParams, {
        energyType: this.topActive,
      });
      let res = await api.DHWAnalysisGasTop(params);
      if (res && res.data.code == 200) {
        res.data.data.slice(0, 5).map((v) => {
          this.gasTopList.xData.push(v.value);
          this.gasTopList.yData.push(v.name);
        });
      }
    },

    async getRunTime() {
      this.runTimeList.xData = [];
      this.runTimeList.dataArr = [];
      let res = await api.DHWAnalysisRunTime(this.pubParams);
      if (res && res.data.code == 200) {
        let arr = [];
        res.data.data.map((v) => {
          this.runTimeList.xData.push(
            this.activeTime.type == "MONTH"
              ? dateFtt("dd日", new Date(v.ts))
              : this.activeTime.type == "YEAR"
              ? dateFtt("MM月", new Date(v.ts))
              : dateFtt("yyyy年", new Date(v.ts))
          );
          arr.push(v.values);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.runTimeList.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.runTimeList.dataArr[i].name = item[i].name;
            this.runTimeList.dataArr[i].data.push(item[i].value);
          });
        }
      }
    },

    async getEcData() {
      this.electricityCharts.unit = "";
      this.electricityCharts.xData = [];
      this.electricityCharts.dataArr = [
        {
          name: matchingECMode(this.dateActive),
          data: [],
        },
      ];
      let params = Object.assign(this.pubParams, {
        energyType: this.dateActive,
      });
      let res = await api.DHWAnalysisEcData(params);
      if (res && res.data.code == 200) {
        this.electricityCharts.unit = res.data.data[0]?.unit;
        res.data.data.map((v) => {
          this.electricityCharts.xData.push(
            this.activeTime.type == "MONTH"
              ? dateFtt("dd日", new Date(v.ts))
              : this.activeTime.type == "YEAR"
              ? dateFtt("MM月", new Date(v.ts))
              : dateFtt("yyyy年", new Date(v.ts))
          );
          this.electricityCharts.dataArr[0].data.push(v.value);
        });
      }
    },

    getFourEC() {
      this.hoursCharts.unit = "";
      this.hoursCharts.xData = [];
      this.hoursCharts.dataArr = [
        { name: matchingECMode(this.hoursActive), data: [] },
      ];
      let params = Object.assign(this.pubParams, {
        energyType: this.hoursActive,
      });
      this.$store.dispatch("publicGetFourEC", { params }).then((res) => {
        this.hoursCharts.unit = res.unit;
        this.hoursCharts.xData = res.xData;
        this.hoursCharts.dataArr[0].data = res.yArr;
      });
    },

    async getTable() {
      this.tableData = [];
      let res = await api.DHWAnalysisEcTable(this.pubParams);
      if (res && res.data.code == 200) {
        this.tableData = Array.from(res.data.data).map((item) => ({
          time:
            this.activeTime.type == "MONTH"
              ? dateFtt("dd日", new Date(item.ts))
              : this.activeTime.type == "YEAR"
              ? dateFtt("MM月", new Date(item.ts))
              : dateFtt("yyyy年", new Date(item.ts)),
          carbonAll: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.carbonAll
              : item.carbonAll / 10000
          ),
          gasAll: handleNumDecimal(
            this.activeTime.type == "MONTH" ? item.gasAll : item.gasAll / 10000
          ),
          flowAll: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.flowAll
              : item.flowAll / 10000
          ),
          electricityAll: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.electricityAll
              : item.electricityAll / 10000
          ),
          combustionFan: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.combustionFan
              : item.combustionFan / 10000
          ),
          airSourceHeatPump: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.airSourceHeatPump
              : item.airSourceHeatPump / 10000
          ),
          boiler: handleNumDecimal(
            this.activeTime.type == "MONTH" ? item.boiler : item.boiler / 10000
          ),
          boilerHotWaterCirculationPump: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.boilerHotWaterCirculationPump
              : item.boilerHotWaterCirculationPump / 10000
          ),
          domesticHotWaterCirculationPump: handleNumDecimal(
            this.activeTime.type == "MONTH"
              ? item.domesticHotWaterCirculationPump
              : item.domesticHotWaterCirculationPump / 10000
          ),
        }));
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.dHWEnergyPage {
  width: 100%;
  overflow: auto;

  .topBox {
    width: $innerWidth;
    height: 450px;
    margin: 0 auto;
    @include setFlexBetween;
    .analysis {
      width: 60%;
      .overviewLi {
        width: 90%;
        // height: 30%;
        margin: 10px auto;
      }
      .comFlex {
        @include setFlexBetween;
        .overviewWrap {
          width: 40%;
          height: 100%;
        }
        .gasTop {
          width: 60%;
          height: 100%;
        }
      }
    }
    .runTime {
      width: calc(40% - 12px);
    }
  }
}
</style>
